import ServiceRequestViewer from "./myserviceRequestViewer";
import { getServiceList } from "../../../../redux/actions/incidentManagement/serviceList.action";
import { connect } from "react-redux";
import { ReadNotification } from "../../../../redux/actions/notification/getEventNotificationList.action";
import { getAllMissingOneItsmCustomers } from "../../../../redux/actions/userManagement/getAllOneItsmServiceMissingCustomer.action";
import { getFilteredCustomers } from "../../../../redux/actions/userManagement/filterCustomers.action";
import { setStatusFilter, setColumnFilters, resetColumnFilters } from "../../../../redux/actions/filters/filter.action";

const mapStateToProps = (state) => {
  return {
    serviceList: state.serviceList,
    myRights : state.myRights.myRights,
    statusCount: state.serviceList.statusCount,
    notificationdata:state?.notifications?.moduleNotification?.data?.data?.SERVICE_REQUEST,
    missingOneItsmCustomers:state?.missingOneItsmCustomers?.data,
    totalCount:state?.missingOneItsmCustomers?.totalcount,
    loadingMissingOneITSMCust:state?.missingOneItsmCustomers?.isLoading,
    filterCustomers:state.onboardingRequest.filterCustomers.customers,
    columnFilters: state?.filtersReducer?.columnFilters?.SERVICEREQUEST || {},
    incidentActiveTab:state.incidentTab.incidentActiveTab,
    statusFilter: state?.filtersReducer?.status?.SERVICEREQUEST
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getServiceList: (next=null,status="",uniqueCustomerRefId="",orderBy="",searchKeyValue="")=>{
      return dispatch(getServiceList(next,status,uniqueCustomerRefId,orderBy,searchKeyValue))
  },
  ReadNotification: (payload,id) => {
    return dispatch(ReadNotification(payload,id))
  },
  getAllMissingOneItsmCustomers: () => {
    return dispatch(getAllMissingOneItsmCustomers())
  },
  getFilteredCustomers: () => {
    return dispatch(getFilteredCustomers())
  },
  setColumnFilters: (screen, columnKey, options) =>{
    return dispatch(setColumnFilters(screen, columnKey, options))
  },
  setStatusFilter: (screen,data) => {
    return dispatch(setStatusFilter(screen, data))
  },
  resetColumnFilters: (screen) => {
    return dispatch(resetColumnFilters(screen))
  },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestViewer);
